import UserSidebarContainer from './container'

export default UserSidebarContainer
